<app-page-wrapper scrollable="true">
  <div class="aircraft-wrapper">
    <app-heavy-header title="Personal Aircraft"
      [description]="hasAircraft === null ? 'Do you have your own aircraft?' : ''"></app-heavy-header>

    <ng-container *ngIf="hasAircraft === null">
      <div class="initial-question">
        <div class="btn-row">
          <app-primary-btn (click)="hasAircraft = true" mb="12px" [gradient]="true">Yes, I have a personal aircraft (Not
            a Broker)</app-primary-btn>
          <app-primary-btn (click)="continueWithoutAircraft()" [gradient]="true">No, skip</app-primary-btn>
        </div>
      </div>
    </ng-container>

    <form *ngIf="hasAircraft" (ngSubmit)="submit(form)" #form="ngForm" class="aircraft-form">
      <div class="field-row">
        <div class="field-set xl" *ngIf="!isOtherAircraft">
          <div class="set-label">Aircraft</div>
          <app-base-select id="defaultAircraft" name="defaultAircraft" placeholder="Select an aircraft"
            [(ngModel)]="defaultAircraft" (ngModelChange)="onSelectAircraft($event)" [options]="aircraftOptions"
            displayField="name" [isFluid]="true" required>
          </app-base-select>
        </div>
        <div class="field-set xl" *ngIf="isOtherAircraft">
          <div class="label-row">
            <div class="set-label">Other Aircraft</div>
            <div class="cancel-text" (click)="viewList()">Show List</div>
          </div>
          <app-base-input id="otherAircraft" name="otherAircraft" placeholder="Enter aircraft name"
            [(ngModel)]="otherAircraft" [isFluid]="true" required autocomplete="off"></app-base-input>
        </div>
        <div class="field-set sm">
          <div class="set-label">Seats</div>
          <app-base-input id="seatingConfiguration" placeholder="Seating Configuration"
            [(ngModel)]="seatingConfiguration" name="seatingConfiguration" type="number" isFluid="true"
            autocomplete="off"></app-base-input>
        </div>
      </div>
      <app-alert-message *ngIf="error" type="error" mb="12px">{{ error }}</app-alert-message>
      <app-primary-btn [disabled]="isLoading" [isLoading]="isLoading" gradient="true" mt="8px">Save</app-primary-btn>
      <app-text-button (handleClick)="onClickBack()" mt="14px" text="Go Back"></app-text-button>

    </form>
  </div>
</app-page-wrapper>
